import { render, staticRenderFns } from "./company-credit-balance.vue?vue&type=template&id=ba072d02&scoped=true&"
import script from "./company-credit-balance.ts?vue&type=script&lang=ts&"
export * from "./company-credit-balance.ts?vue&type=script&lang=ts&"
import style0 from "./company-credit-balance.vue?vue&type=style&index=0&id=ba072d02&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba072d02",
  null
  
)

export default component.exports